import React from 'react';

const About = () => (
  <div className="about__content">
    <h2 className="about__list">
      TO-DO List App , Created by Omar Farouq
    </h2>
  </div>
);
export default About;
